/**
 * @generated SignedSource<<f0b69b30b790d8ef097f4aebcaec6649>>
 * @relayHash 170b3094f11ce4762d08d06d69d822ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe459a836bcc2615a19fe481c82e0405ffec025a965435965adac0c143edce4e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybooksPanelBodyQuery } from './PlaybooksPanelBodyQuery.graphql';

const node: PreloadableConcreteRequest<PlaybooksPanelBodyQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fe459a836bcc2615a19fe481c82e0405ffec025a965435965adac0c143edce4e",
    "metadata": {},
    "name": "PlaybooksPanelBodyQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
